module.exports = __webpack_public_path__ + "static/media/Tumblr.e02342bb.svg";